import React, { useState, useContext, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import useEventsTableQuery from "./useEventsTableQuery.js";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import UserService from "services/UserService";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import { deleteEvent } from "services/ConfigServices";
//import "react-table/react-table.css";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import { withStyles } from "@mui/styles";
// @mui/icons-material
import Edit from "@mui/icons-material/Edit";
import Tooltip from '@mui/material/Tooltip';
import styled from "styled-components";
import ReactLoading from "react-loading";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';
import { eventpagetext } from "variables/event";
import { statusData } from "variables/lists/event";
import EventDialog from "./EventDialog.js";

const useStyles = makeStyles(styles);
const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles2 = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: '16px',
    },
  },
}));
const LinearIndeterminate = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress />
    </div>
  );
};

const LoadingDiv = styled.div`
height: 20vh;
width: 20vw;
display: flex;
flex-wrap: nowrap;
align-content: center;
justify-content: center;
padding-top: 10vh;
`;
const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const ExpandableComponent = props => {
  const { data } = props;
  const classes = useStyles2();
  const SubTabs = () => {
    return (
      <>
        <div>
          <ExpandableElement>
            <ElementTitle>{eventpagetext.description} : </ElementTitle>
            <ElementData>{data.parameters?.description}</ElementData>
          </ExpandableElement>
        </div>

      </>
    );
  };
  return (
    <Container>
      <ExpandableContainer>
        <div>
          <SubTabs />
        </div>
      </ExpandableContainer>
    </Container>
  );
};

const RTAlertes = () => {
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const eventsadmin = permis.includes("events_admin");
  const [open, setOpen] = useState(false);
  const { gridState, refreshTable, setSelectedEvents, setLoading } = useEventsTableQuery();
  const [row, setRow] = useState();
  const [rowClicked, setRowClicked] = useState();
  const [currentEvent, setCurrentEvent] = useState('');

  useEffect(() => {
    setPage('events');
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  let dataEvents = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: eventpagetext.title,
      selector: row => row.parameters.title,
      key: "title",
      sortable: true,
      width: "8rem",
    },
    {
      name: eventpagetext.datebegin,
      selector: row => row.parameters.datebegin,
      key: "datebegin",
      sortable: true,
      width: "12rem",
      cell: (row) =>
        row.parameters.datebegin && moment(row.parameters.datebegin).isValid()
          ? moment(row.parameters.datebegin).format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: eventpagetext.status,
      selector: (row) => row.parameters.status,
      key: "status",
      sortable: true,
      width: "12rem",
      // maxWidth: "12rem",
      cell: (row) => row.parameters.status ?
        <div style={{ color: statusData.find((x) => x.id == row.parameters.status).color, fontWeight: "bold" }}>
          {statusData.find((x) => x.id == row.parameters.status).name}
        </div> : <></>
    },
    {
      name: eventpagetext.dateend,
      selector: row => row.parameters.dateend,
      key: "dateend",
      sortable: true,
      width: "12rem",
      cell: (row) =>
        row.parameters.dateend && moment(row.parameters.dateend).isValid()
          ? moment(row.parameters.dateend).format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: eventpagetext.category,
      selector: row => row.parameters.category,
      key: "category",
      sortable: true,
      width: "8rem",
    },
    {
      name: eventpagetext.groups,
      selector: (row) => row.idgroup,
      sortable: true,
      cell: (row) => (
        <GroupCell>
          <div>{groupInfoListById["" + row.idgroup]}</div>
        </GroupCell>
      ),
      width: "8rem",
    },
    {
      name: eventpagetext.author,
      selector: row => row.parameters.author,
      key: "author",
      sortable: true,
    },
    {
      name: "",
      sortable: false,
      width: "7rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {eventsadmin && (
              <>
                <Tooltip title="Editer l'évènement">
                  <Button
                    color={"success"}
                    className={classes.actionButton}
                    onClick={editEvent(row)}
                  >
                    <Edit className={classes.icon} />
                  </Button>
                </Tooltip>
                <CustomDeleteButton
                  deleteTitle={"Suppression de l'évènement"}
                  deleteSubTitle={
                    "Êtes-vous sûr de vouloir supprimer l'évènement ?"
                  }
                  handleSupprimer={deleteEventRow(row)}
                /></>
            )}
          </div>
        </>
      ),
    },
  ];

  const deleteEventRow = (row) => async () => {
    axios
      .delete(
        deleteEvent(row.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then(() => {
        refreshTable();
      })
      .catch(() => { });
  };

  const editEvent = (row) => async () => {
    let obj = dataEvents.find((o) => o.id === row.id);
    setCurrentEvent(obj);
    handleClickOpen();
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedEvents(selection.selectedRows);
  };


  return (
    <>
      <div style={{ paddingTop: 10 }}>
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          //title="Tableau d'alertes"
          noDataComponent={<NoData>Aucun évènement à afficher</NoData>}
          noHeader={true}
          columns={columns}
          persistTableHead
          sortServer
          pagination
          paginationServer
          paginationPerPage={20}
          subHeader
          selectableRows={true}
          onSelectedRowsChange={handleSelectedRowsChange}
          expandOnRowClicked
          expandableRows
          expandableRowDisabled={(row) => row.disabled}
          expandableRowsComponent={ExpandableComponent}
          paginationComponentOptions={
            {
              noRowsPerPage: false,
              rowsPerPageText: "Lignes par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les lignes"
            }
          }
          progressPending={gridState.loading}
          progressComponent={<div><LoadingDiv><ReactLoading
            type={"bars"}
            color={"#91c241"}
            height={"10%"}
            width={"10%"}
          /></LoadingDiv></div>}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="md"
          open={open}
        >
          <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose}>
            Edition d'un évènement
          </CustomDialogTitle>
          <DialogContent dividers>
            <EventDialog
              currentEvent={currentEvent}
              rowClicked={rowClicked}
              closeModal={handleClose}
              refetch={refreshTable}
              setLoading={setLoading}
            />
          </DialogContent>
          <DialogActions />
        </Dialog>
        <NotificationContainer />
      </div>
    </>
  );
};

export default RTAlertes;
